"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IntegrationType = void 0;
var IntegrationType;
exports.IntegrationType = IntegrationType;
(function (IntegrationType) {
  IntegrationType["CUSTODIAN_SILVERGATE"] = "CUSTODIAN_SILVERGATE";
  IntegrationType["EXCHANGE_BEQUANT"] = "EXCHANGE_BEQUANT";
  IntegrationType["EXCHANGE_BINANCE"] = "EXCHANGE_BINANCE";
  IntegrationType["EXCHANGE_BINANCEUS"] = "EXCHANGE_BINANCEUS";
  IntegrationType["EXCHANGE_BITFINEX"] = "EXCHANGE_BITFINEX";
  IntegrationType["EXCHANGE_BITFLYER"] = "EXCHANGE_BITFLYER";
  IntegrationType["EXCHANGE_BITMEX"] = "EXCHANGE_BITMEX";
  IntegrationType["EXCHANGE_BITSTAMP"] = "EXCHANGE_BITSTAMP";
  IntegrationType["EXCHANGE_BITTREX"] = "EXCHANGE_BITTREX";
  IntegrationType["EXCHANGE_BYBIT"] = "EXCHANGE_BYBIT";
  IntegrationType["EXCHANGE_CROSSTOWER"] = "EXCHANGE_CROSSTOWER";
  IntegrationType["EXCHANGE_DERIBIT"] = "EXCHANGE_DERIBIT";
  IntegrationType["EXCHANGE_FTX"] = "EXCHANGE_FTX";
  IntegrationType["EXCHANGE_GDAX"] = "EXCHANGE_GDAX";
  IntegrationType["EXCHANGE_GEMINI"] = "EXCHANGE_GEMINI";
  IntegrationType["EXCHANGE_HITBTC"] = "EXCHANGE_HITBTC";
  IntegrationType["EXCHANGE_HUOBI"] = "EXCHANGE_HUOBI";
  IntegrationType["EXCHANGE_HUOBIDM"] = "EXCHANGE_HUOBIDM";
  IntegrationType["EXCHANGE_ITBIT"] = "EXCHANGE_ITBIT";
  IntegrationType["EXCHANGE_KRAKEN"] = "EXCHANGE_KRAKEN";
  IntegrationType["EXCHANGE_KUCOIN"] = "EXCHANGE_KUCOIN";
  IntegrationType["EXCHANGE_LIQUID"] = "EXCHANGE_LIQUID";
  IntegrationType["EXCHANGE_LMAX"] = "EXCHANGE_LMAX";
  IntegrationType["EXCHANGE_OKCOIN"] = "EXCHANGE_OKCOIN";
  IntegrationType["EXCHANGE_OKEX"] = "EXCHANGE_OKEX";
  IntegrationType["EXCHANGE_POLONIEX"] = "EXCHANGE_POLONIEX";
  IntegrationType["EXCHANGE_SEEDCX"] = "EXCHANGE_SEEDCX";
})(IntegrationType || (exports.IntegrationType = IntegrationType = {}));
var _default = IntegrationType;
exports.default = _default;